export const selectDigitalTwinState = state => state.machineDetails.digitalTwin;

export const selectDigitalTwinScene = state => selectDigitalTwinState(state).scene;

/**
 * Returns the same object reference when all output values are strictly equal to the
 * previous call. This prevents connect() from re-rendering the heavy 3D component on
 * unrelated store updates — without pulling in reselect as a dependency.
 */
function shallowMemoize(fn) {
  let lastResult = null;
  return function (state) {
    const next = fn(state);
    if (lastResult !== null) {
      let same = true;
      const keys = Object.keys(next);
      for (let i = 0; i < keys.length; i++) {
        if (next[keys[i]] !== lastResult[keys[i]]) { same = false; break; }
      }
      if (same) return lastResult;
    }
    lastResult = next;
    return next;
  };
}

export const selectDigitalTwinSummary = shallowMemoize((state) => {
  const scene = selectDigitalTwinScene(state);
  return {
    componentCount: scene.components.length,
    locationCount: scene.locations.length,
  };
});

export const selectDigitalTwinEditState = shallowMemoize((state) => {
  const slice = selectDigitalTwinState(state);
  return {
    editMode: slice.editMode,
  };
});
